import { RateQuote } from '../../rate';
import { RoutingGuideRule } from '../../routingGuide';
import { ProposedShipment } from '../ProposedShipment';

import { ProposedShipmentCreationResult } from './ProposedShipmentCreationResult';

export class ProposedShipmentRateQuote {
  proposedShipment?: ProposedShipment;
  result?: ProposedShipmentCreationResult;
  rateQuote?: RateQuote;
  routingGuideRule?: RoutingGuideRule;

  constructor(opts?: Partial<ProposedShipmentRateQuote>) {
    if (opts?.proposedShipment) {
      this.proposedShipment = new ProposedShipment(opts.proposedShipment);
    }

    if (opts?.result) {
      this.result = new ProposedShipmentCreationResult(opts.result);
    }

    if (opts?.rateQuote) {
      this.rateQuote = new RateQuote(opts.rateQuote);
    }

    if (opts?.routingGuideRule) {
      this.routingGuideRule = new RoutingGuideRule(opts.routingGuideRule);
    }
  }
}
